/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Create_Duplicate_ClientInputs */

const fr_person_create_duplicate_client = /** @type {(inputs: Person_Create_Duplicate_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce client apparaît plusieurs fois. Regroupez ses projets dans une seule section client.`)
};

const en_person_create_duplicate_client = /** @type {(inputs: Person_Create_Duplicate_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This client appears more than once. Keep its projects in a single client section.`)
};

/**
* | output |
* | --- |
* | "This client appears more than once. Keep its projects in a single client section." |
*
* @param {Person_Create_Duplicate_ClientInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_create_duplicate_client = /** @type {((inputs?: Person_Create_Duplicate_ClientInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Create_Duplicate_ClientInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_create_duplicate_client(inputs)
	return fr_person_create_duplicate_client(inputs)
});